import { render, staticRenderFns } from "./EquipmentTypeForm.vue?vue&type=template&id=5b627bf2"
import script from "./EquipmentTypeForm.vue?vue&type=script&lang=js"
export * from "./EquipmentTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports